import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'next/link';

import StyledCampaignStage from './campaignStage.style';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import LongArrowRight from '../../icons/longArrowRight.svg';
import Picture from '../../atoms/picture/picture';

const CampaignStage = ({ headline, subline, titleImage, video, mobileVideo, stageLink }) => (
  <StyledCampaignStage>
    <div className="campaignStage__wrapper">
      {(titleImage || video) && (
        <div className="campaignStage__media">
          {titleImage && !video && <Picture {...titleImage} sizes={[{ width: '100vw' }]} />}
          {video && mobileVideo && (
            <>
              <video autoPlay muted playsInline loop className="campaignStage__media--desktop">
                <source src={video} type="video/mp4" />
              </video>
              <video autoPlay muted playsInline loop className="campaignStage__media--mobile">
                <source src={mobileVideo} type="video/mp4" />
              </video>
            </>
          )}
        </div>
      )}
      <Container>
        <div className="campaignStage__headline">
          <Headline tag="h1" primary disableHyphens>
            {headline}
          </Headline>
          <MixedCopy fullWidth html={subline} />
          {stageLink && (
            <Link
              href={{
                pathname: '/universal',
                query: { uri: stageLink.uri }
              }}
              as={stageLink.uri}
              className="campaignStage__link"
              title={stageLink.label}
            >
              <LongArrowRight width="60px" height="20px" />
              <Copy thick noMargin>
                {stageLink.label}
              </Copy>
            </Link>
          )}
        </div>
      </Container>
    </div>
  </StyledCampaignStage>
);

CampaignStage.propTypes = {
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string.isRequired,
  titleImage: PropTypes.shape({
    imageFormat: PropTypes.oneOf(['portrait', 'landscape']),
    credits: PropTypes.string
  }),
  video: PropTypes.string,
  mobileVideo: PropTypes.string,
  stageLink: PropTypes.shape({
    uri: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })
};

const mapStateToProps = ({ app }) => ({
  headline: app.pageData.headline,
  subline: app.pageData.subline,
  titleImage: app.pageData.titleImage,
  video: app.pageData.video,
  mobileVideo: app.pageData.mobileVideo,
  stageLink: app.pageData.stageLink
});

export default connect(mapStateToProps)(CampaignStage);
